import 'react';
import { jsx } from '@emotion/core';
import { CardHeader, ButtonGroup, Button, Icon } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import useStores from "../hooks/useStores.js";

function PdfToolbar(_ref) {
  var children = _ref.children;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  return jsx(CardHeader, {
    className: "d-flex justify-content-between shadow-sm flex-shrink-0"
  }, jsx("div", null, children), jsx(ButtonGroup, null, jsx(Button, {
    className: "text-dark",
    color: "link",
    onClick: function onClick() {
      pdfStore.zoomIn();
    }
  }, jsx(Icon, {
    name: "search-plus",
    size: "lg"
  })), jsx(Button, {
    className: "text-dark",
    color: "link",
    onClick: function onClick() {
      pdfStore.zoomOut();
    }
  }, jsx(Icon, {
    name: "search-minus",
    size: "lg"
  }))));
}

PdfToolbar.displayName = "PdfToolbar";
var PdfToolbar$1 = observer(PdfToolbar);
export default PdfToolbar$1;